const SEEN_STORAGE_KEY = "loadingAnimationSeen"
// Set in <head> by layout/theme.liquid for ad / UTM-tagged landings.
const SKIP_CLASS = "skip-loading-animation"

const LEAVE_FALLBACK_MS = 1800

class LoadingAnimation extends HTMLElement {
    constructor() {
        super()

        this.text = this.querySelector(".text-appear-animation")
    }

    connectedCallback() {
        this.onlyShowOnce = this.hasAttribute("data-only-show-once")

        if (
            document.documentElement.classList.contains(SKIP_CLASS) ||
            (this.onlyShowOnce && this.hasBeenSeen())
        ) {
            this.remove()
            return
        }

        if (this.onlyShowOnce) this.markAsSeen()

        const holdDuration = parseInt(this.dataset.holdDuration, 10)
        this.holdDuration = Number.isNaN(holdDuration) ? 1000 : holdDuration

        if (window.lenis) window.lenis.stop()

        this.waitForTextAppear().then(() => {
            window.setTimeout(() => this.slideUp(), this.holdDuration)
        })
    }

    hasBeenSeen() {
        try {
            return sessionStorage.getItem(SEEN_STORAGE_KEY) === "true"
        } catch (error) {
            return false
        }
    }

    markAsSeen() {
        try {
            sessionStorage.setItem(SEEN_STORAGE_KEY, "true")
        } catch (error) {
            // sessionStorage unavailable (private browsing, disabled storage,
            // etc.) — fail open, the animation will simply play again.
        }
    }

    waitForTextAppear() {
        if (!this.text || !window.TextAppear) return Promise.resolve()

        window.TextAppear.activate(this.text)

        if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
            return Promise.resolve()
        }

        const words = this.text.querySelectorAll(".block > span")
        const lastWord = words[words.length - 1]
        if (!lastWord) return Promise.resolve()

        return new Promise((resolve) => {
            let done = false
            const finish = () => {
                if (done) return
                done = true
                resolve()
            }

            lastWord.addEventListener("transitionend", finish, { once: true })

            window.setTimeout(finish, 800)
        })
    }

    slideUp() {
        let done = false
        const finish = () => {
            if (done) return
            done = true
            this.removeEventListener("transitionend", onTransitionEnd)
            if (window.lenis) window.lenis.start()
            this.remove()
        }
        // Ignore transitionend bubbling up from the text's word animations.
        const onTransitionEnd = (event) => {
            if (event.target === this) finish()
        }

        this.addEventListener("transitionend", onTransitionEnd)
        // Browsers without @property never fire transitionend for --mask-out.
        window.setTimeout(finish, LEAVE_FALLBACK_MS)

        this.classList.add("is-leaving")
    }
}

customElements.define("loading-animation", LoadingAnimation)